import { HttpErrorResponse } from '@angular/common/http';
import { ApiError, ERROR_CODE_ALREADY_EXIST } from './models/safe-crypto.models';

/**
 * Stable BE error code from the response body, or null when the response
 * carries no recognisable error envelope (network failure, HTML error page,
 * an unmapped 500).
 */
export function apiErrorCode(error: HttpErrorResponse): number | null {
  const body = error.error as Partial<ApiError> | null | undefined;
  return typeof body?.code === 'number' ? body.code : null;
}

/**
 * True only for a genuine "already exists" rejection. Callers must branch on
 * this rather than on the HTTP status: a duplicate transaction hash is 400
 * today and is planned to become 409, while a bare 500 on the same endpoint
 * is a real server fault that must stay visible.
 */
export function isAlreadyExistError(error: HttpErrorResponse): boolean {
  return apiErrorCode(error) === ERROR_CODE_ALREADY_EXIST;
}
